<form [formGroup]="realEstateTitleForm">
  <div class="grid-container">
    <div class="grid-item department">
      <div style="display: flex">
        <div class="formField">
          <mat-form-field>
            <mat-label> Real Estate Department </mat-label>
            <mat-select formControlName="realEstateDepartment" required>
              @for (department of realEstateDepartments; track department) {
                <mat-option [value]="department.value">
                  {{ department.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    @if (realEstateSelected) {
      <div class="grid-item funding-type formField">
        <mat-form-field>
          <mat-label> Funding Type </mat-label>
          <mat-select formControlName="fundingType" required>
            @for (type of filteredFundingTypes; track type) {
              <mat-option [value]="type.value">
                {{ type.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (realEstateSelected) {
      <div class="grid-item checkboxes-expenditure-type">
        <mat-checkbox
          class="stackedCheckBox"
          formControlName="fm"
          (change)="onCheckboxChange('FM')"
        >
          FM
        </mat-checkbox>
        <mat-checkbox
          class="stackedCheckBox"
          formControlName="pm"
          (change)="onCheckboxChange('PM')"
        >
          PM
        </mat-checkbox>
        <mat-checkbox class="stackedCheckBox" formControlName="myrp"> MYRP </mat-checkbox>
      </div>
    }

    @if (landServicesSelected) {
      <div class="grid-item checkboxes-land-services">
        <div>
          <mat-checkbox
            class="stackedCheckBox"
            formControlName="acquisition"
            (change)="onCheckboxChange('ACQUISITION')"
          >
            Acquisition
          </mat-checkbox>
          <mat-checkbox
            class="stackedCheckBox"
            formControlName="disposal"
            (change)="onCheckboxChange('DISPOSAL')"
          >
            Disposal
          </mat-checkbox>
        </div>
        <div>
          <mat-checkbox
            class="stackedCheckBox"
            formControlName="land"
            (change)="onCheckboxChange('LAND')"
          >
            Land
          </mat-checkbox>
          <mat-checkbox
            class="stackedCheckBox"
            formControlName="building"
            (change)="onCheckboxChange('BUILDING')"
          >
            Building
          </mat-checkbox>
        </div>
      </div>
    }
  </div>

  @if (landServicesSelected) {
    <div class="land-services-section">
      <div>
        <div>
          <div class="formField region">
            <mat-form-field>
              <mat-label> Region </mat-label>
              <mat-select formControlName="region" required>
                @for (region of regions; track region) {
                  <mat-option [value]="region.value">
                    {{ region.viewValue }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        @if (landServicesSelected) {
          <div class="grid-item checkboxes-land-services">
            <div>
              <mat-checkbox class="stackedCheckBox" formControlName="estimate">
                Estimate
              </mat-checkbox>
              <mat-checkbox class="stackedCheckBox" formControlName="projectDate">
                Project Date
              </mat-checkbox>
              <mat-checkbox class="stackedCheckBox" formControlName="changeInScope">
                Change in Scope
              </mat-checkbox>
            </div>
            <div>
              <mat-checkbox class="stackedCheckBox" formControlName="capitalExpenditure">
                Capital Expenditure
              </mat-checkbox>
              <mat-checkbox class="stackedCheckBox" formControlName="omExpenditure">
                O&M Expenditure
              </mat-checkbox>
            </div>
          </div>
        }
      </div>
    </div>
  }
</form>
